var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('v-btn',{attrs:{"flat":"","fab":"","small":"","color":"default"},on:{"click":_vm.exportData}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("backup")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("Export sheet (CSV)")))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }